import { TAppState } from 'src/redux/createAdminStore'
import { Entity, TEntityName } from '@obvious.tech/constellation/Entity'

export const selectApi = (state: TAppState) => {
  return state.api
}

export const selectIsMicroserviceAvailable =
  (microservice?: string) =>
  (state: TAppState): boolean => {
    if (typeof microservice !== 'string') return false

    const availableMicroservices = selectApi(state)
    return microservice in availableMicroservices
  }

export const selectIsEntityMicroserviceAvailable =
  (entity?: TEntityName) =>
  (state: TAppState): boolean => {
    if (typeof entity !== 'string') return false

    const resource = Entity.getResource(entity)
    const microservice = resource.split('/')[2]
    return selectIsMicroserviceAvailable(microservice)(state)
  }